import {useEffect, useState} from "react";

export const useFetchProductFulfillment = (sku) => {
    const [productFulfillment, setProductFulfillment] = useState([]);

    useEffect(() => {
        const fetchProductFulfillment = async () => {
            try {
                const rsp = await fetch(`api/fulfillmentStatus/${sku}`);
                const text = await rsp.text();
                if (!rsp.ok) {
                    console.error(`fulfillmentStatus ${sku} failed: ${rsp.status}`, text || "(empty body)");
                    setProductFulfillment([]);
                    return;
                }
                if (!text || !text.trim()) {
                    console.error(`fulfillmentStatus ${sku}: empty response body`);
                    setProductFulfillment([]);
                    return;
                }
                setProductFulfillment(JSON.parse(text));
            } catch (e) {
                console.error(`fulfillmentStatus ${sku}:`, e);
                setProductFulfillment([]);
            }
        };
        fetchProductFulfillment();
    }, [sku]);

    return productFulfillment;
};